export const MESSAGE_TYPE = {
  ERROR: 'ERROR',
  WARNING: 'WARNING',
  SUCCESS: 'SUCCESS',
  REGULAR: 'INFO'
};